import { render } from "./BlogDetailsPage.vue?vue&type=template&id=272229da&ts=true"
import script from "./BlogDetailsPage.vue?vue&type=script&lang=ts"
export * from "./BlogDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__